// removed by extract-text-webpack-plugin
module.exports = {"Wrap":"_33Oxl"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Flight/Wrappers/AirlineWrapper/AirlineWrapper.scss
// module id = 506
// module chunks = 0